app.config(function($mdThemingProvider, $qProvider, $routeProvider, $locationProvider) {
    $mdThemingProvider.theme('default').primaryPalette('light-blue');
    $locationProvider.html5Mode({ enabled: true, requireBase: false });
    $routeProvider
    .when("/", {
        redirectTo: '/index.php',
    })
    .when("/index.php", {
        template : '<home-main></home-main>',
    })
    .when("/home", {
        template : '<home-main></home-main>',
    })
    .when("/eatlife_check_top", {
        template : '<eatlife-check_top></eatlife-check_top>',
    })
    .when("/eatlife_check_main", {
        template : '<eatlife-check-main></eatlife-check-main>',
    })
    .when("/eatlife_check_result/:gradescore", {
        template : '<eatlife-check-result></eatlife-check-result>',
    })
    .when("/foodbalance_basiccheck", {
        template : '<foodbalance-basiccheck></foodbalance-basiccheck>',
    })
    .when("/foodbalance_result", {
        template : '<foodbalance-result></foodbalance-result>',
    })
    .when("/medical_main", {
        template : '<medical-main></medical-main>',
    })
    .when("/medical_result", {
        template : '<medical-result></medical-result>',
    })
    .when("/medical_add/:entry/:medicalId/:mode", {
        template : '<medical-add></medical-add>',
    })
    .when("/recipe_main/:tabIndex", {
        template : '<recipe-main></medical-main>',
    })
    .when("/recipe_detail/:recipeid/:tabIndex", {
        template : '<recipe-detail></recipe-detail>',
        reloadOnSearch : true,
    })
    .when("/user_policy", {
        template : '<user-policy></user-policy>',
    })
    .otherwise({
        redirectTo: '/'
    });
});

app.run(function($window, $location, localStorageAccess) {
    var appData = localStorageAccess.getData( "app" );
    if(appData == null) {
        appData = {};
        appData.lastRunDate = "初回起動";
        appData.runCount = "1";
        appData.userPolicy = "0";
    }
    else {
        appData.runCount = parseInt(appData.runCount)+1;
    }
    var userAgent = $window.navigator.userAgent.toLowerCase();
    appData.isIE = "0";
    if(userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
        appData.isIE = "1";
    }
    localStorageAccess.setData("app", appData);

    angular.element(window).on("beforeunload", function(e) {
        var appData = localStorageAccess.getData( "app" );
        appData.lastRunDate = moment().format("YYYY.MM.DD");
        localStorageAccess.setData("app", appData);
    });

    if(appData.userPolicy == null || appData.userPolicy == "0") {
        appData.userPolicy = "0";
        localStorageAccess.setData("app", appData);
        $location.path("/user_policy");
    };
});